<template>
  <base-section
    id="curriculum-alt"
    space="56"
  >
    <v-container>
      <v-row justify="center">
        <!-- <base-subheading
          align="center"
          title="OFERTA DE EMPLEO ABIERTA"
          class="text-uppercase"
          space="2"
        /> -->
        <v-col
          cols="12"
        >
          <base-section-heading title="Bolsa de Empleo" />
        </v-col>

        <!-- <v-col
          cols="12"
          md="5"
        >
          <base-business-info title="MANTÉNGASE EN CONTACTO CON NOSOTROS">
            Puede enviarnos sus consultas por email o llamándonos a los siguientes números de teléfono. Si lo prefiere, también puede cumplimentar y enviarnos el siguiente formulario, o visitar nuestras instalaciones.
          </base-business-info>
        </v-col> -->

        <v-col
          cols="12"
          md="8"
        >
          <base-curriculum-form title="ENVÍANOS TU CURRICULUM" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionCurriculum',
  }
</script>
